import React from 'react';
import { Row, Col, Skeleton } from 'antd';

interface FormSkeletonProps {
  rows?: number;
  cols?: number;
  labelWidth?: string;
  inputHeight?: string;
  gutter?: number;
  className?: string;
  showSubmitButton?: boolean;
  submitButtonWidth?: string;
  submitButtonHeight?: string;
  submitButtonClassName?: string;
  hideLabel?: boolean;
}

const FormSkeleton: React.FC<FormSkeletonProps> = ({
  rows = 1,
  cols = 2,
  labelWidth = '!w-36',
  inputHeight = '!h-10',
  gutter = 24,
  className = '',
  showSubmitButton = false,
  submitButtonWidth = '!w-36',
  submitButtonHeight = '!h-10',
  submitButtonClassName = '',
  hideLabel = false,
}) => {
  return (
    <div className={`space-y-6 ${className}`} data-testid="form-skeleton-container">
      {!hideLabel && (
        <div data-testid="title-skeleton">
          <Skeleton.Input className={`!h-10 rounded mb-6`} active />
        </div>
      )}
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <Row key={rowIndex} gutter={gutter} data-testid="form-skeleton-row">
          {Array.from({ length: cols }).map((_, colIndex) => (
            <Col key={colIndex} xs={24} md={24 / cols}>
              <div className="mb-6">
                {!hideLabel && (
                  <div data-testid="form-skeleton-label">
                    <Skeleton.Input className={`${labelWidth} !h-6 rounded mb-2`} active />
                  </div>
                )}
                <div data-testid="form-skeleton-input">
                  <Skeleton.Input className={`!w-full ${inputHeight} rounded`} active />
                </div>
              </div>
            </Col>
          ))}
        </Row>
      ))}
      {showSubmitButton && (
        <div className="flex justify-start">
          <div data-testid="form-skeleton-submit">
            <Skeleton.Button
              className={`rounded ${submitButtonWidth} ${submitButtonHeight} ${submitButtonClassName}`}
              active
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default FormSkeleton;
